import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_debit_note = async (debitNote) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-debit-note`, debitNote, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_debit_note = async (debitNote) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-debit-note`, debitNote, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_debit_note = async (debitNote) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-debit-note`, debitNote, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_debit_notes = async (filters) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-all-debit-notes`, filters, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_debit_notes_by_purchase_order = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-debit-notes-by-purchase-order`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const delete_debit_note = async (debitNote) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/delete-debit-note`, debitNote, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const create_debit_notes_csv = async (customer) => {
  try {
    let data = new FormData();
    data.append("file", customer?.file);

    const token = localStorage.getItem("user");

    const response = await axios.post(`${APIURL}/create-debit-notes-csv`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_debit_note,
  update_debit_note,
  get_debit_note,
  get_all_debit_notes,
  get_debit_notes_by_purchase_order,
  delete_debit_note,
  create_debit_notes_csv
};